module.exports = __webpack_public_path__ + "media/3.9dcbdcba.mp3";